module.exports = __webpack_public_path__ + "static/art3d-8114e28da4509ff8716c77c4910e9600.jpeg";